/**
 * Hello Mrs — patches product-info so custom variant galleries are not overwritten on variant change.
 * Load after product-info.js on hello-featured-product sections only.
 */
(function () {
  function patchProductInfo() {
    const ProductInfo = customElements.get('product-info');
    if (!ProductInfo?.prototype?.updateMedia) return false;

    if (ProductInfo.prototype.updateMedia.__helloPatched) return true;

    const originalUpdateMedia = ProductInfo.prototype.updateMedia;
    ProductInfo.prototype.updateMedia = function (html, variantFeaturedMediaId) {
      if (this.dataset.helloCustomGallery === 'true') return;
      return originalUpdateMedia.call(this, html, variantFeaturedMediaId);
    };
    ProductInfo.prototype.updateMedia.__helloPatched = true;
    return true;
  }

  if (!patchProductInfo()) {
    customElements.whenDefined('product-info').then(patchProductInfo);
  }
})();
